module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equipPussui"
  }, [_c('span', {
    staticClass: "nao"
  }, [_vm._v("Não possui")]), _vm._v(" "), _c('label', {
    staticClass: "i-switch bg-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : (_vm.model)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.__set]
    }
  }), _vm._v(" "), _c('i')]), _vm._v(" "), _c('span', {
    staticClass: "sim"
  }, [_vm._v("Possui")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a555526","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/CheckPossui.vue
// module id = 1809
// module chunks = 17